// extracted by mini-css-extract-plugin
module.exports = {"mobile":"styles_mobile__1Gd1B","tablet":"styles_tablet__2_8kZ","desktop":"styles_desktop__1x6Zc","tag-wrapper":"styles_tag-wrapper__18okg"};